import api from '../../utils/api'

export const sendConfirmApi = (params) => api.get('/managers/users/confirm_email', { params })
